import * as React from "react";
import type { SVGProps } from "react";

interface PenaltyProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Penalty = ({ cancelled = false, ...props }: PenaltyProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M12 .75C5.787.75.75 5.787.75 12S5.787 23.25 12 23.25 23.25 18.213 23.25 12 18.213.75 12 .75"
      />
      <path
        fill="#000"
        d="M12 1.7C6.311 1.7 1.7 6.311 1.7 12S6.311 22.3 12 22.3 22.3 17.689 22.3 12 17.689 1.7 12 1.7M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18"
      />
      <path
        fill="#FF1212"
        d="M9.212 17.8q-.912 0-.912-.944V7.544q0-.945.944-.944h4.176q1.568 0 2.488.736.92.735.92 2.48t-.92 2.496-2.488.752h-3.28v3.792q0 .944-.928.944m.928-6.464h3.024q.816 0 1.264-.352t.448-1.168q0-.8-.448-1.152t-1.264-.352H10.14z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Penalty;
